import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppUtilityService } from '../app-utility.service';
import { QuoteStoreService } from '../core/rest-services/quote-store.service';

@Injectable({ providedIn: 'root' })
export class QuoteNavigatorService {
  constructor(
    private router: Router,
    private quoteStoreService: QuoteStoreService,
    private global_utility: AppUtilityService // assuming this wraps loading + navigation
  ) {}

  navigateFromNewClientSelection(quote: any, relativeTo?: ActivatedRoute): void {
    if (!quote || !quote.status || !quote.quoteId) {
      console.warn('Invalid quote selection:', quote);
      return;
    }

    this.global_utility.startLoading('Routing based on quote status...');

    this.quoteStoreService.getQuoteDetailsById(quote.quoteId).subscribe({
      next: (result) => {
        if (!result) {
          this.global_utility.stopLoading();
          return;
        }

        if(!result.loanStatus || !result.id) {
          if(result.errorMessage) {
            this.global_utility.error(result.errorMessage, 'Quote details error');
          } else {
            this.global_utility.error('Quote details are incomplete, routing is not supported', 'Quote details error');
          }
          console.warn('Quote details missing unsupported:', result);
          this.global_utility.stopLoading();
          return;
        }

        const { loanStatus, quoteId, offer, capital, employerName, id } = result;

        // Handle New with incomplete data
        if (loanStatus === 'New') {
          const isIncomplete = !capital || capital === 0 || !employerName;
          const route = isIncomplete ? '/search' : `/clientDetails/${quote.quoteId}`;

          this.quoteStoreService.PreAuthorisationModel = result; // set selected quote in store for client details page
          this.quoteStoreService.PreAuthorisationModel.id = quote.quoteId; // ensure ID is set for client details page
          this.quoteStoreService.PreAuthorisationModel.quoteId = quote.quoteId; // ensure quoteId is set for client details page
          void this.router.navigate([route], { relativeTo });
        }

        // Handle Active with or without offer
        else if (loanStatus === 'Active') {
          this.quoteStoreService.setQuoteWorkbook(result);
          const route = offer ? '/quoteOffer' : '/quote';
          this.global_utility.navigateToURL([route], { relativeTo });
        }

        // Handle other known statuses
        else {
          const routeMap: Record<string, string> = {
            Submitted: '/fbloanAgreement',
            NuPay: '/registerLoan',
            Journal: '/disburseLoan',
            Pending: '/quote',
          };

          const route = routeMap[loanStatus];

          if (route) {
            this.quoteStoreService.setQuoteWorkbook(result);
            this.global_utility.navigateToURL([route], { relativeTo });
          } else {
            console.warn(`No defined route for loanStatus: ${loanStatus}`);
            this.global_utility.navigateToURL(['/quoteSummary', quoteId], { relativeTo });
          }
        }

        this.global_utility.stopLoading();
      },
      error: (err) => {
        console.error('Error loading quote details:', err);
        this.global_utility.stopLoading();
      },
    });
  }

  // navigate(quote: QuoteModel, relativeTo?: ActivatedRoute): void {
  //   if (!quote || !quote.status) return;

  //   const { status, quoteId, capital, employerName, offer } = quote;
  //   const isIncomplete = !capital || capital === 0 || !employerName;

  //   let path: string;
  //   switch (status) {
  //     case 'New':
  //       path = isIncomplete ? '/search' : `/clientDetails/${quoteId}`;
  //       break;

  //     case 'Pending':
  //       path = '/quote';
  //       break;

  //     case 'Active':
  //       path = offer ? '/quoteOffer' : '/quote';
  //       break;

  //     case 'Submitted':
  //       path = '/fbloanAgreement';
  //       break;

  //     case 'NuPay':
  //       path = '/registerLoan';
  //       break;

  //     case 'Journal':
  //       path = '/disburseLoan';
  //       break;

  //     default:
  //       path = `/quoteSummary/${quoteId}`;
  //       break;
  //   }

  //   const navArgs: any[] = [path];
  //   const options: any = {};

  //   // Use state or queryParams if needed
  //   if (status === 'Pending') {
  //     options.state = { qid: quoteId };
  //   }

  //   if (relativeTo) {
  //     options.relativeTo = relativeTo;
  //   }

  //   void this.router.navigate(navArgs, options);
  // }
}
